import AssignRoleDropdown from "components/group/assignRoleDropdown"
import GroupUserList from "components/group/groupUserList"
import { TabPanel, TabView } from "primereact/tabview"
import { useParams } from "react-router-dom"
import { ToastContent, toast } from "react-toastify"
import { useCallback, useEffect, useState } from "react"
import GroupDetails from "components/group/groupDetails"
import { getGroupsByIdService } from "services/groupService"
import FlagInfo from "components/group/FlagInfo"
import { useDispatch, useSelector } from "react-redux"
import { handleLoader, handleNotFound } from "redux/counterSlice"
// import { addUsersData, getUsersDataById } from "services/userService"

const AddUpdateGroup = () => {
	const permissions = useSelector((state: any) => state.persistent.group_permissions);
	const params = useParams()
	const dispatch = useDispatch();
	const [data, setData] = useState<{ [s: string]: any }>({})
	const [groupName, setGroupName] = useState<string>()
	const fetchGroupData = useCallback(
		async (id: string | undefined) => {
			dispatch(handleLoader(true));
			try {
				const { response, error } = await getGroupsByIdService(id)
				// const {
				// 	result,
				// 	error,
				// }: { result: { [s: string]: any }; error: unknown } = {
				// 	result: {
				// 		id: 1,
				// 		name: "Advent",
				// 		description: "A descent group",
				// 		assigned_roles: [
				// 			{ role_id: 1, name: "admin" },
				// 			{ role_id: 2, name: "staff" },
				// 		],
				// 		unassigned_roles: [
				// 			{ role_id: 3, name: "sales" },
				// 			{ role_id: 2, name: "agent" },
				// 		],
				// 		assigned_users: [
				// 			{ id: 1, first_name: "anand", last_name: "patel" },
				// 		],
				// 		unassigned_users: [
				// 			{ id: 2, first_name: "viren", last_name: "vaishnav" },
				// 		],
				// 	},
				// 	error: undefined,
				// }
				if (error) {
					throw error
				}
				if (response?.error) {
					throw response?.error
				}
				dispatch(handleLoader(false));
				setGroupName(response?.name)
				setData(response)
			} catch (error) {
				dispatch(handleLoader(false));
				toast.error(error as ToastContent<unknown>, {
					style: {
						backgroundColor: '#F1F1F1', // Grey background
					}
				})
			}
		},
		[setData]
	)

	useEffect(() => {
		if (params.id !== "add") {
			fetchGroupData(params.id ?? "")
		}
	}, [fetchGroupData, params.id])

	useEffect(() => {
		dispatch(handleNotFound(false))
	}, [])

	return (
		<div className="content-wrapper p-4">
			<div className="user-group user-management-section">
				<h4 className="mb-3">
					{params.id !== "add" ? "Edit Group" : "Add Group"}
				</h4>
				<div className="user-group-card">
					<div className="user-group-body">
						<div className="tabs-wrap">
							{params.id === "add" ? (
								<GroupDetails
									{...{ name: data.name, description: data.description, add: permissions.add, edit: permissions.edit }}
								/>
							) : (
								<>
									{permissions?.edit && (
										<TabView>
											<TabPanel header="Details">
												<GroupDetails
													{...{ name: data.name, description: data.description, add: permissions.add, edit: permissions.edit }}
												/>
											</TabPanel>
											<TabPanel header="Assign Roles">
												<AssignRoleDropdown
													{...{
														fetchGroupData,
														assigned_roles: data.assigned_roles,
														unassigned_roles: data.unassigned_roles,
													}}
												/>
											</TabPanel>
											<TabPanel header="Assign Users">
												<GroupUserList
													{...{
														fetchGroupData,
														assigned_users: data.assigned_users,
														unassigned_users: data.unassigned_users,
													}}
												/>
											</TabPanel>
											<TabPanel header="Flag Manage">
												<FlagInfo name={groupName ?? ""} />
											</TabPanel>
										</TabView>
									)}
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AddUpdateGroup
